import { useRef, useState, useEffect, React } from "react";
import { useBlogContext } from "../../fetchdata/BlogContext";
import Header from "../components/Header"; // Replace this with your Header component
import Footer from "../components/Footer";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import axiosInstance, { Homeurl,keyLogin } from "../../axiosInstance";


// import required modules
import { Pagination, Navigation } from "swiper/modules";
import RangeSlider from "../components/extra/RangeSlider";
import { Helmet } from "react-helmet";
import CreateSlug from "../components/extra/CreateSlug";
import { encrypt } from "../../helper/encryption";
import setCookie from "../../helper/setCookie";
import getDecryptData from "../../helper/getDecryptData";
import LocationSearchBox from "../components/extra/Locationsearchbox";

const Category = () => {
  const { Headers, isHeader,LocationHeaders } = useBlogContext();


    const [showSearch, setShowSearch] = useState("false");
    const toggleSearch = () => {
      setShowSearch(!showSearch);
    };


  const navigate = useNavigate();

  const [enquireData, setEnquireData] = useState([]);

  const [layout, setLayout] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [isProducts, setIsProducts] = useState(true);

  const [RProducts, setRProducts] = useState([]);

  const [OTPVerify, setOTPVerify] = useState(false);
  const [GetOtpRes, setOtpRes] = useState(null);
  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state
  const [ExistingUser, setExistingUser] = useState([]);


        const verifyOTPFinal = async () => {
          setSubmitLoading(false); // Set loading to false after request completion
      
          const MYOTPinputs = { OTP: enquireData.otp, HASHOTP: GetOtpRes.otp }
      
          try {
            const response = await axiosInstance.post(`/login-verify-otp`, MYOTPinputs); // Await the axios post request
            console.log('responseresponse', response)
            const { success } = response.data
            if (success) {
      
              setOTPVerify(true);
      
            }
          } catch (error) {
            console.error('Error On OTP Verify:', error);
            toast.error(error.response.data.message);
            setOTPVerify(false);
  
          } finally {
            setSubmitLoading(true); // Set loading to false after request completion
          }
       
        }
        const ChangePhone = async () => {
          setOTPVerify(false);
          setOtpRes(null);
          setEnquireData((prevData) => ({
            ...prevData,
            otp: null,
          })); // Clear form fields

        }

    const submitOTP = async (phone) => {
      if (!phone) {
        toast.error('Please Enter a phone number.');
        return null;

      } else if (phone.length !== 10) {
        toast.error('Please Enter a 10-digit phone number.');
        return null;
      }  
      setSubmitLoading(false); // Set loading to true before making the request
      const inputs = {
        phone:phone
      }
      setOtpRes(null);
      try {
        const response = await axiosInstance.post(`/signup-login-new/`, inputs); // Await the axios post request
        console.log('responseresponse', response)
        setOtpRes(response.data); // Set the response data to state
        // console.log('dataotp', response.data.password);
        const { existingUser} = response.data;
        if(existingUser){
          setExistingUser(existingUser);
        }

      } catch (error) {
        console.error('Error On taxes:', error);
        toast.error(error.response.data.message);
      } finally {
        setSubmitLoading(true); // Set loading to false after request completion
      }
    };

  
  const getProducts = async () => {
        const decryptdatajson = await getDecryptData();
        if (decryptdatajson && decryptdatajson?._id) {
 
          setEnquireData((prevData) => ({
            ...prevData,
            fullname: decryptdatajson.username,
            email: decryptdatajson.email,
            phone: decryptdatajson.phone,

          })); // Clear form fields
          setOtpRes(true);
          setEnquireData((prevData) => ({
            ...prevData,
            otp: null,
          })); // Clear form fields

          setOTPVerify(true);

        }

    try {
      const { data } = await axiosInstance.get("/all-home-products");
      setRProducts(data.products);
      setIsProducts(false); // Set loading state to false in case of an error
    } catch (error) {
      console.error("Error fetching products:", error);
      setIsProducts(false); // Set loading state to false in case of an error
    }
  };

  const getData = async () => {
    try {
      const { data } = await axiosInstance.get(`/home-layout-data`);
      setLayout(data.homeLayout);
      setIsLoading(false); // Set loading state to false in case of an error
    } catch (error) {
      console.log(error);
      toast.error("Error fetching Home layout!");
      setIsLoading(false); // Set loading state to false in case of an error
    }
  };

  useEffect(() => {
    getData();
    getProducts();
  }, []);

  const startMin = 0;
  const startMax = 100;
  const min = 0;
  const max = 200;
  const step = 1;

  const [selectedRanges, setSelectedRanges] = useState([]);

  const [selectedFilters, setSelectedFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [Cat, setCat] = useState([]);
  const [CatT, setTCat] = useState([]);
  const [CatImage, setTCatImage] = useState("");

  const [CatM, setMCat] = useState([]);

  const [Pro, setPro] = useState([]);
  const [Attr, setAttr] = useState([]);
  const [fillter, setfillter] = useState("");

  const [Viewfillter, setViewfillter] = useState([]);

  const [isCat, setIsCat] = useState(true);
  const [count, setcount] = useState("100");
  const [Sidebar, setIsSidebar] = useState(false);

  const handlecountChange = (event) => {
    setcount(event.target.value);
  };

  const { id ,location} = useParams();
  const capLocation = location?.charAt(0).toUpperCase() + location?.slice(1);
   const capitalizedLocation = capLocation.replaceAll('-', ' ');
  const isDynamicCategoryLayout = Boolean(location && id);
 
  const [products, setProducts] = useState([]);
  const [productSearchTerm, setProductSearchTerm] = useState("");
  const [ratings, setRatings] = useState([]);

  const getRating = async () => {
    // try {
    //   const { data } = await axiosInstance.get(`/all-rating`);
    //   setRatings(data.ratings);
    //   // console.log('getRating', data)
    // } catch (error) {
    //   console.error("Error fetching rating:", error);
    // }
  };

  const [Specifications, setspecifications] = useState([]);

  const getCategory = async (fillter, page, price) => {
    setIsSidebar(false);
    if (window.__PRELOADED_DATA__?.MainCat?.slug !== id || window.__PRELOADED_DATA__ === undefined) {
      try {
        // window.scrollTo(0, 0);
        setIsCat(true);
        const encodedFilter = encodeURIComponent(fillter); // Encode the filter string
         const { data } = await axiosInstance.get(
          `/all/category-slug/${id}?filter=${encodedFilter}&price=${price}&page=${page}&perPage=${count}&location=${location}`
        );
        setCat([]);
        setTCat([]);
        setMCat([]);
        if (data?.success) {
          setCat(data?.categories);
          setTCat(data.MainCat);
          console.log("data.MainCat", data.MainCat);
          setEnquireData((prevData) => ({
            ...prevData,
            service: data.MainCat?.title,
            category: data.MainCat?.title,
          })); // Clear form fields

          setspecifications(data.MainCat.specifications.specifications || []);

          setTCatImage(data.MainCat.image);
          setTotalPages(data?.proLength);
          setfillter(fillter);

          setProducts(data?.productsFilter);
         console.log('setProducts',data?.productsFilter)
          setPro(data?.products);
          setMCat(data?.MainCat);
        }

        // console.log('datadatadata', data)
      } catch (error) {
        console.log(error);
        toast.error("Error fetching Category!");
        navigate("/404");
      } finally {
        setIsCat(false);
      }
    } else {

      setCat([]);
      setTCat([]);
      setMCat([]);

      setCat(window.__PRELOADED_DATA__?.categories);
      setTCat(window.__PRELOADED_DATA__.MainCat);
      console.log("data.MainCat", window.__PRELOADED_DATA__.MainCat);
      setEnquireData((prevData) => ({
        ...prevData,
        service: window.__PRELOADED_DATA__.MainCat?.title,
      })); // Clear form fields
      setspecifications(window.__PRELOADED_DATA__.MainCat.specifications.specifications || []);

      setTCatImage(window.__PRELOADED_DATA__.MainCat.image);
      setTotalPages(window.__PRELOADED_DATA__?.proLength);
      setfillter(fillter);

      setProducts(window.__PRELOADED_DATA__?.productsFilter);

      setPro(window.__PRELOADED_DATA__?.products);
      setMCat(window.__PRELOADED_DATA__?.MainCat);

      setIsCat(false);

    };
  };

  const Opensidebar = async () => {
    setIsSidebar(true);
  };
  const Closesidebar = async () => {
    setIsSidebar(false);
  };

  const getAttribute = async () => {
    try {
      const { data } = await axiosInstance.get("/all-attribute");
      // console.log("attr", data);
      setAttr(data.Attribute);
    } catch (error) {
      console.error("Error fetching attributes:", error);
    }
  };

    // Function to handle checkbox selection
    const handleCheckboxChange = (event) => {
      const { value, checked } = event.target;
      // console.log('valuevaluevalue', value)
      setSelectedFilters((prevState) => {
        // If checked, add the value to selectedFilters, otherwise remove it
        if (checked) {
          return { ...prevState, [value]: checked };
        } else {
          const { [value]: removedValue, ...rest } = prevState;
          return rest;
        }
      });
  
      // console.log('selectedFilters', selectedFilters)
      setCurrentPage(1);
    };

  // Function to handle checkbox selection
  const handleCheckboxChangeOld = (event) => {
    const { value, checked } = event.target;
    const [attrName, attrValue] = value.split(",");
  
    setSelectedFilters((prevFilters) => {
      const existing = prevFilters[attrName]?.split(",") || [];
  
      const updated = checked
        ? [...new Set([...existing, attrValue])] // Add unique
        : existing.filter((v) => v !== attrValue); // Remove unchecked
  
      if (updated.length === 0) {
        const { [attrName]: removed, ...rest } = prevFilters;
        return rest;
      }
  
      return {
        ...prevFilters,
        [attrName]: updated.join(","),
      };
    });
  
    setCurrentPage(1);
  };
  

  const removeFilter = ({ key, val }) => {
    const value = `${key},${val}`;
    setSelectedFilters((prevState) => {
      const { [value]: removedValue, ...rest } = prevState;
      return rest;
    });

    setCurrentPage(1); // Set current page to 1
  };

  const generateQueryString = () => {
    const filterObj = {};

    // Construct filter object from selected filters
    Object.entries(selectedFilters).forEach(([key, value]) => {
      const [attrKey, attrValue] = key.split(",");

      // Check if attribute key already exists in filter object
      if (filterObj[attrKey]) {
        // Append to existing attribute value if key exists
        filterObj[attrKey] += `,${attrValue}`;
      } else {
        // Create new attribute if key doesn't exist
        filterObj[attrKey] = attrValue;
      }
    });

    // Convert filter object to JSON string
    const filterString = JSON.stringify(filterObj);

    // console.log(filterString); // Output the generated filter string
    setViewfillter(filterString);
    setTimeout(function () {
      getCategory(filterString, currentPage, selectedRanges);
    }, 100);
  };

  // const handleCategoryLinkClick = (categoryId) => {
  //   getCategory(fillter, currentPage, selectedRanges);
  // };

  useEffect(() => {
    generateQueryString(); // Call generateQueryString when selectedFilters change
    getRating();
    setIsCat(true); // Set loading state to true
    getAttribute();
    
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
         
           setEnquireData((prevData) => ({
            ...prevData,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          })); // Clear form fields

          console.log("Latitude:", position.coords.latitude);
          console.log("Longitude:", position.coords.longitude);
        },
        
      );
    } else {
      toast.error('Geolocation is not supported by this browser.');
      return null;
     }


    // getCategory(fillter,currentPage,selectedRanges);
  }, [id, currentPage, selectedFilters, selectedRanges, count,location]); // Empty dependency array ensures that the effect runs once after the initial render

  useEffect(() => {
    setSelectedRanges([]);
  }, [id]); // Empty dependency array ensures that the effect runs once after the initial render

  // useEffect(() => {
  //   generateQueryString(); // Call generateQueryString when selectedFilters change
  // }, [selectedFilters,selectedRanges]); // Add selectedFilters as a dependency

  // Function to filter products based on selected attributes

  const [priceRange, setPriceRange] = useState({ min: 0, max: 100 });

  function handleChange(e) {
    setPriceRange({
      priceRange,
      [e.target.name]: parseInt(e.target.value),
    });
  }

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Calculate the maximum sale price to determine the range
  const maxSalePrice = Math.max(
    ...products.map((product) => product.salePrice)
  );

  // Determine the number of ranges based on the maximum sale price
  const numRanges = Math.ceil(maxSalePrice / 10000);

  // Generate price ranges dynamically
  const priceRanges = Array.from({ length: numRanges }, (_, index) => ({
    min: index * 10000,
    max: (index + 1) * 10000,
  }));

  // Filter out the price ranges that match the actual sale prices of your products
  const filteredPriceRanges = priceRanges.filter((range) =>
    products.some(
      (product) =>
        product.salePrice >= range.min && product.salePrice < range.max
    )
  );

  const searchedProducts = Pro.filter((product) => {
    const term = productSearchTerm.trim().toLowerCase();
    if (!term) {
      return true;
    }

    const vendorName = product?.userId?.username || "";
    return (
      product?.title?.toLowerCase().includes(term) ||
      vendorName.toLowerCase().includes(term)
    );
  });

  const handleCheckpriceboxChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setSelectedRanges([...selectedRanges, value]);
    } else {
      setSelectedRanges(selectedRanges.filter((range) => range !== value));
    }
    setCurrentPage(1);
    // console.log(selectedRanges)
  };

  const addedVariations = new Set();

  const visibleFilterAttributes = Attr.filter((attr) =>
    products.some(
      (product) =>
        product.variations &&
        product.variations.some((variation) => variation.name === attr.name)
    )
  );

  const parsedViewFilters = (() => {
    try {
      return Viewfillter ? JSON.parse(Viewfillter) : {};
    } catch (error) {
      return {};
    }
  })();

  const lookingForAttribute = visibleFilterAttributes.find((attr) => {
    const attrName = attr.name?.trim().toLowerCase().replace(/\?$/, "");
    return attrName === "looking for";
  });

  const getLookingForTabLabel = (value) =>
    value
      ?.split(" ")
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  const lookingForTabs = Array.isArray(lookingForAttribute?.value)
    ? lookingForAttribute.value.filter(Boolean).map((value) => ({
        value,
        label: getLookingForTabLabel(value),
      }))
    : [];

  const activeLookingForValues = lookingForAttribute
    ? Object.keys(selectedFilters)
        .filter((key) => key.startsWith(`${lookingForAttribute.name},`))
        .map((key) => key.slice(lookingForAttribute.name.length + 1))
    : [];

  const handleLookingForTabChange = (attrName, attrValue) => {
    setSelectedFilters((prevState) => {
      const nextState = Object.fromEntries(
        Object.entries(prevState).filter(([key]) => !key.startsWith(`${attrName},`))
      );

      return {
        ...nextState,
        [`${attrName},${attrValue}`]: true,
      };
    });

    setCurrentPage(1);
  };


   const [loading, setLoading] = useState(true); // Add loading state
 
  const [EnquireShow, setEnquireShow] = useState(false);

  const [EnquireStatus, setEnquireStatus] = useState(false);

  const [StepForm, setStepForm] = useState(0);
  

   const [data, setData] = useState([]);
    const [filteredCities, setFilteredCities] = useState([]);
  
  
   
     const fetchData = async () => {
      setLoading(true);
      console.log("response.data start");
  
      try {
        const response = await axiosInstance.get("/get-all-zones");
        console.log("response.data.Zones,", response.data.Zones);
        setData(response.data.Zones);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      fetchData();
    }, []); // Empty dependency array ensures that the effect runs once after the initial render
  

  const handleNext = () => {
    setStepForm((prevStep) => prevStep + 1);
  };

  const handlePrevious = () => {
    setStepForm((prevStep) => prevStep - 1);
  };



  const enquireToggle = () => {
    if (EnquireShow) {
      setEnquireShow(false);
    } else {
      setEnquireShow(true);
    }
  };

  const capitalizeEachWord = (str) => {
    if (!str) return str;
    str = str.replace(/\d+/g, "");
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const validate = (email) => {
    // Regular expression to check for invalid characters
    const invalidCharsRegex = /[^\w@_.]| /; // Disallow spaces and any character that's not a word character, @, or .

    // Check for invalid cases
    if (email === "-" || email === "+") {
      return "";
    } else if (invalidCharsRegex.test(email)) {
      return ""; // Return empty string if invalid characters (including spaces) are found
    } else {
      return email; // Return the original email if valid
    }
  };

  const handleEnquireChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Determine the new value based on input type
    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else {
      newValue = value;
    }

    // Capitalize each word for specific fields
    if (name === "fullname") {
      newValue = capitalizeEachWord(newValue);
    }

    if (name === "email") {
      newValue = validate(newValue);
    }

    if (name === "phone") {
      // Replace non-digit characters
      newValue = value.replace(/\D/g, ""); // This allows only digits

      // if (newValue.startsWith('0')) {
      //   newValue = newValue.slice(1); // Remove the first '0'
      // } 

      // Limit to 10 digits
      if (newValue.length > 13) {
        newValue = newValue.slice(0, 13); // Limit to 10 digits
      }
    }

  // Capitalize text for the 'username' field
  if (name === "state") {
    const selectedState = data.find((state) => state._id === newValue);
    if (selectedState) {
      setFilteredCities(selectedState.cities);
      setEnquireData((prevData) => ({
        ...prevData,
        statename: selectedState.name,
        city: "",
      }));
    }
    console.log("selectedState", selectedState, newValue, data);
  }


    // Update form data with the new value
    setEnquireData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

  const handleSendEnquire = async () => {
    const fields = [
      { name: "phone", message: "Please enter phone number" },
    ];

    for (const field of fields) {
      if (!enquireData[field.name]) {
        toast.error(field.message);
        setEnquireStatus(false);
        return;
      }
    }

    if (String(enquireData.phone).length !== 10) {
      toast.error("Please enter a 10-digit phone number");
      setEnquireStatus(false);
      return;
    }
   


    try {
      setEnquireStatus(true);
    const  data = await toast.promise(axiosInstance.post(`/send-enquire-category`, enquireData), {
        loading: "Enquire Submiting...", // Loading message
        success: "Enquire Submited Successfully!", // Success message
        error: "Failed to Submit Enquire.", // Error message
      });

            const { success, user } = data.data;
              if (success) {
                if(user){
                  const { _id, username, email, type, phone } = user;
                  const userToStore = { _id, username, email, type, phone };
        
                  // Encrypt the user data and set a cookie
                  const encryptedData = encrypt(JSON.stringify(userToStore), keyLogin);
                  setCookie('token', encryptedData, 7); // Expires in 7 days
        
                }
             
                enquireToggle();
                setEnquireData((prevData) => ({
                  ...prevData,
                 
                  requirement: "",
                })); // Clear form fields

              } 

    
    } catch (error) {
      console.error("Failed to send email:", error);
    toast.error(error?.response?.data?.message);
    } finally {
      setEnquireStatus(false);
    }
  };

    useEffect(() => {
      if(OTPVerify && ExistingUser && ExistingUser._id){
        const { _id, username, email, type, phone } = ExistingUser;
          const userToStore = { _id, username, email, type, phone };
  
        // Encrypt the user data and set a cookie
        const encryptedData = encrypt(JSON.stringify(userToStore), keyLogin);
        setCookie('token', encryptedData, 7); // Expires in 7 days
  
        setTimeout(() => {
        
          window.location.reload(); // Corrected method to reload the page
        
        }, 500);
  
      }
    }, [OTPVerify]);

  return (
    <>
      <Header />
      {isDynamicCategoryLayout && (
        <style>{`
          .dentist-category-page {
            background: #dcebfa;
            border-radius: 10px;
            max-width: 100%;
            padding-left: 22px;
            padding-right: 22px;
          }
          .dentist-category-page .dentist-top-search {
            background: #cfe4f6;
            border-radius: 4px;
            padding: 14px;
          }
          .dentist-category-page .dentist-location-chip,
          .dentist-category-page .dentist-search-box {
            background: #fff;
            border: 1px solid #b6c8d8;
            border-radius: 4px;
            min-height: 48px;
          }
          .dentist-category-page .dentist-location-search {
            position: relative;
          }
          .dentist-category-page .dentist-location-search .searchbox {
            background: transparent !important;
            display: flex !important;
            margin-right: 0 !important;
            max-width: none !important;
          }
          .dentist-category-page .dentist-location-search .searchinput {
            background: transparent;
            border: 0;
            box-shadow: none;
            font-weight: 600;
            min-height: 46px;
            padding-left: 12px;
          }
          .dentist-category-page .dentist-location-search .searchfloat {
            left: 0;
            min-width: 100%;
            right: auto;
            top: calc(100% + 4px);
            z-index: 30;
          }
          .dentist-category-page .dentist-filter-rail {
            background: #cfe4f6;
            border: 1px solid #b7cede;
            border-radius: 4px;
            overflow: hidden;
          }
          .dentist-category-page .dentist-filter-section {
            border-bottom: 1px solid #b7cede;
            padding: 14px 16px;
          }
          .dentist-category-page .dentist-filter-title {
            color: #252b36;
            font-size: 18px;
            font-weight: 700;
            margin-bottom: 8px;
          }
          .dentist-category-page .dentist-chip {
            align-items: center;
            background: #fff;
            border: 1px solid #333;
            border-radius: 999px;
            display: inline-flex;
            font-size: 13px;
            gap: 8px;
            line-height: 1;
            margin: 0 10px 10px 0;
            max-width: 180px;
            padding: 8px 10px;
          }
          .dentist-category-page .dentist-chip span:first-child {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .dentist-category-page .dentist-tabs {
            border-bottom: 1px solid #97aec1;
            display: flex;
          }
          .dentist-category-page .dentist-tab {
            background: #fff;
            border: 1px solid #d7e0ea;
            border-bottom: 0;
            color: #d90000;
            font-size: 20px;
            font-weight: 800;
            padding: 10px 18px;
          }
          .dentist-category-page .dentist-tab.active {
            background: #07156d;
            color: #fff;
          }
          .dentist-category-page .category-feature-grid {
            background: transparent !important;
            border: 0 !important;
            border-radius: 0 !important;
            margin-left: 0 !important;
            margin-right: 0 !important;
            padding: 0 !important;
          }
          .dentist-category-page .dentist-list-col {
            flex: 0 0 100%;
            max-width: 100%;
            padding: 0;
          }
          .dentist-category-page .dentist-list-card {
            align-items: stretch;
            background: #cfe4f6 !important;
            border: 0 !important;
            border-radius: 0 !important;
            box-shadow: none;
            display: grid;
            grid-template-columns: minmax(320px, 2fr) minmax(190px, 1.25fr) 110px 130px 100px;
            min-height: 88px;
          }
          .dentist-category-page .dentist-list-card .card-body {
            display: contents;
          }
          .dentist-category-page .dentist-product-image {
            display: none !important;
          }
          .dentist-category-page .dentist-inline-image {
            background: #fff;
            border: 1px solid #b7cede;
            border-radius: 6px;
            flex: 0 0 86px;
            height: 70px;
            margin-right: 12px;
            object-fit: cover;
            width: 86px;
          }
          .dentist-category-page .dentist-main-cell,
          .dentist-category-page .dentist-detail-cell,
          .dentist-category-page .dentist-time-cell,
          .dentist-category-page .dentist-distance-cell,
          .dentist-category-page .dentist-rating-cell,
          .dentist-category-page .dentist-price-cell,
          .dentist-category-page .dentist-action-cell {
            align-items: center;
            border-bottom: 1px solid #dcecf8;
            display: flex;
            min-width: 0;
            padding: 12px 14px;
          }
         
          .dentist-category-page .dentist-table-head {
            background: #fff;
            border-bottom: 1px solid #6f8596;
            display: grid;
            font-weight: 800;
            grid-template-columns: minmax(320px, 2fr) minmax(190px, 1.25fr) 110px 130px 100px;
            padding: 12px 14px;
          }
          .dentist-category-page .dentist-main-cell .product-title {
            font-size: 18px;
            font-weight: 800;
            margin: 0 0 5px;
          }
          .dentist-category-page .dentist-muted-line {
            color: #515b66;
            font-size: 14px;
            line-height: 1.35;
          }
          .dentist-category-page .dentist-detail-cell {
            color: #df0000;
            flex-direction: column;
            font-weight: 700;
            justify-content: center;
            overflow: visible;
            position: relative;
          }
          .dentist-category-page .dentist-detail-title {
            color: #111;
            font-weight: 800;
            text-align: center;
          }
          .dentist-category-page .dentist-feature-hover {
            cursor: default;
            position: relative;
          }
          .dentist-category-page .dentist-feature-popover {
            background: #fff;
            border: 1px solid #b7cede;
            border-radius: 8px;
            box-shadow: 0 12px 24px rgba(16, 24, 40, .18);
            color: #1f2937;
            display: none;
            font-size: 13px;
            font-weight: 600;
            left: 50%;
            line-height: 1.35;
            max-height: 220px;
            min-width: 220px;
            overflow-y: auto;
            padding: 10px 12px;
            position: absolute;
            text-align: left;
            top: calc(100% + 8px);
            transform: translateX(-50%);
            z-index: 20;
          }
          .dentist-category-page .dentist-feature-popover-title {
            color: #111827;
            font-size: 13px;
            font-weight: 800;
            margin-bottom: 6px;
          }
          .dentist-category-page .dentist-feature-popover ul {
            list-style: none;
            margin: 0;
            padding: 0;
          }
          .dentist-category-page .dentist-feature-popover li {
            border-top: 1px solid #eef2f7;
            padding: 6px 0;
          }
          .dentist-category-page .dentist-feature-popover li:first-child {
            border-top: 0;
          }
          .dentist-category-page .dentist-feature-hover:hover .dentist-feature-popover,
          .dentist-category-page .dentist-feature-hover:focus-within .dentist-feature-popover {
            display: block;
          }
          .dentist-category-page .dentist-time-cell,
          .dentist-category-page .dentist-distance-cell {
            color: #101828;
            font-weight: 800;
          }
          .dentist-category-page .dentist-rating-badge {
            border: 1px solid #df4861;
            border-radius: 4px;
            color: #101828;
            font-weight: 800;
            padding: 6px 8px;
          }
          .dentist-category-page .dentist-price-cell {
            color: #d90000;
            flex-direction: column;
            font-weight: 800;
            justify-content: center;
            text-align: right;
          }
          .dentist-category-page .dentist-price-cell del {
            color: #5d6670;
            font-size: 12px;
            font-weight: 600;
          }
          .dentist-category-page .dentist-book-btn {
            background: #df0000;
            border-color: #df0000;
            border-radius: 999px;
            box-shadow: 0 5px 8px rgba(0,0,0,.35);
            color: #fff;
            font-weight: 800;
            padding: 8px 18px;
          }
          .dentist-category-page .dentist-preferred-lab {
            background: #cfe4f6;
            border: 1px solid #b7cede;
            border-radius: 4px;
            margin-top: 16px;
            padding: 16px;
          }
          .dentist-category-page .dentist-mobile-toolbar {
            display: none;
          }

            .dentist-category-page .dentist-feature-popover { 
             top: 20px; 
            }
          @media (max-width: 991px) {
            .dentist-category-page {
              padding-left: 12px;
              padding-right: 12px;
            }
            .dentist-category-page .dentist-list-card,
            .dentist-category-page .dentist-table-head {
              grid-template-columns: 1fr;
            }
            .dentist-category-page .dentist-table-head {
              display: none;
            }
            .dentist-category-page .dentist-list-card {
              background: #fff !important;
              border: 1px solid #b7cede !important;
              border-radius: 8px !important;
              box-shadow: 0 6px 16px rgba(16, 24, 40, .08);
              margin-bottom: 14px;
              overflow: hidden;
            }
            .dentist-category-page .dentist-main-cell,
            .dentist-category-page .dentist-detail-cell,
            .dentist-category-page .dentist-time-cell,
            .dentist-category-page .dentist-distance-cell,
            .dentist-category-page .dentist-rating-cell,
            .dentist-category-page .dentist-price-cell,
            .dentist-category-page .dentist-action-cell {
              border-bottom: 0;
              padding: 8px 12px;
            }
            .dentist-category-page .dentist-main-cell {
              align-items: flex-start;
              background: #f5fbff;
              border-bottom: 1px solid #dcecf8;
              padding-top: 12px;
            }
            .dentist-category-page .dentist-inline-image {
              flex-basis: 72px;
              height: 58px;
              width: 72px;
            }
            .dentist-category-page .dentist-detail-cell,
            .dentist-category-page .dentist-price-cell {
              align-items: flex-start;
              text-align: left;
            }
            .dentist-category-page .dentist-detail-title {
              text-align: left;
            }
            .dentist-category-page .dentist-feature-popover {
              left: 0;
              max-width: calc(100vw - 48px);
              min-width: min(260px, calc(100vw - 48px));
              transform: none;
             top: 25px;

            }
            .dentist-category-page .dentist-rating-cell {
              justify-content: flex-start;
            }
            .dentist-category-page .dentist-price-cell {
              flex-direction: row;
              justify-content: flex-start;
            }
            .dentist-category-page .dentist-action-cell {
              padding-bottom: 14px;
              padding-top: 4px;
            }
            .dentist-category-page .dentist-book-btn {
              width: 100%;
            }
            .dentist-category-page .dentist-tabs {
              display: none;
            }
            .dentist-category-page .dentist-mobile-toolbar {
              align-items: center;
              display: flex;
              gap: 10px;
              justify-content: space-between;
              margin-bottom: 12px;
            }
            .dentist-category-page .dentist-mobile-filter-btn {
              align-items: center;
              background: #07156d;
              border: 0;
              border-radius: 999px;
              color: #fff;
              display: inline-flex;
              font-weight: 800;
              gap: 6px;
              padding: 8px 14px;
            }
          }
        `}</style>
      )}

      <div className="bg-white">
        {/* Page Title */}
        {/* <div
          className="py-4 mb-4 mb-lg-0 white"
          style={{ backgroundColor: "whitesmoke" }}
        >
          <div className="container d-lg-flex justify-content-between align-items-center py-2 py-lg-4">
            <div className="pe-lg-4 text-center text-lg-start">
              <h1 className="h3 mb-0">
                {CatT ? <> {CatT.title} </> : <> </>} Category{" "}
              </h1>
            </div>
            <div className="pt-2 pt-lg-0">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb flex-lg-nowrap justify-content-center justify-content-lg-start">
                  <li className="breadcrumb-item">
                    <Link className="text-nowrap" to="/">
                      <i className="ri-store-2-line" /> Home{" "}
                    </Link>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div> */}
        {/* Page Title */}
        {/* Product Category */}
        <div className={`container mt-4 pb-4 pb-lg-10 ${isDynamicCategoryLayout ? "dentist-category-page" : ""}`}>
          {isDynamicCategoryLayout && (
            <div className="dentist-top-search row g-3 align-items-center mb-4">
              <div className="col-lg-2">
                <div className="dentist-location-chip dentist-location-search d-flex align-items-center">
                  <LocationSearchBox
                    locations={LocationHeaders}
                    showSearch={showSearch}
                  />
                </div>
              </div>
              <div className="col-lg-10">
                <div className="dentist-search-box d-flex align-items-center px-3">
                  <i className="ri-search-line text-danger fs-3 me-2"></i>
                  <input
                    className="form-control border-0 shadow-none"
                    type="search"
                    placeholder={`Medical Service Provider Name`}
                    value={productSearchTerm}
                    onChange={(event) => setProductSearchTerm(event.target.value)}
                  />
                </div>
              </div>
            </div>
          )}
          <div className="row g-md-4">
         
            {/* Content */}

            <aside className="col-md-12" style={{ flex: 1 }}>
              {CatImage !== undefined && CatImage !== "" ? (
                <>
                  <div
                    className="bg-image p-4"
                    style={{
                      backgroundImage: `url('${CatImage}'`,
                      aspectRatio: "5/1",
                    }}
                  >
                    <div className="row align-items-center">
                      <div className="col-md-8">
                      <h1 className="text-white">  {CatT.slide_head?.replace(/\$\{location\}/g, capitalizedLocation)}  </h1>
                      <p className="text-white">{CatT.slide_para?.replace(/\$\{location\}/g, capitalizedLocation)}</p>
                      </div>
                      <div className="col-md-4">
                          
 
              <div className=" bg-light p-4 border-bottom mb-2 border rounded " style={{boxShadow:'0px 0px 23px #00ffdd'}}>
                <h5
                  className="border-bottom pb-2"
                  style={{ textTransform: "uppercase" }}
                >
               ENQUIRE FOR {CatT ? <> {CatT.title} </> : <> </>} {" "}
                  <i className="ri-chat-3-fill"></i>
                </h5>
                {/* Name input */}
            
                <div className="mb-4 col-12">
                        <label className="form-label text-dark" htmlFor="name">
                          Phone (Preferred WhatsApp No.) <span className="text-danger"> (Required)</span>
                        </label>
                        <div className=" d-flex gap-2  input-sm">
                          <input
                            type="number"
                            id="phone"
                            className={`form-control ${!OTPVerify && 'bg-white' }`}
                            name="phone"
                            value={enquireData.phone}
                            disabled={OTPVerify}
                            onChange={(e) => {
                              if (e.target.value.length <= 10 && !OTPVerify) {
                                // Check input length before updating
                                handleChange(e); // Call handleChange if length is within limit
                              }
                            }}
                            onInput={(e) => {
                              const inputValue = e.target.value;
                              if (inputValue.length <= 10 && !OTPVerify) {
                                setEnquireData({ ...enquireData, phone: inputValue });
                              }
                            }}
                          // onChange={() => {
                          //   handleChange();
                          // }}
                          />
                          {GetOtpRes && OTPVerify && 
                             <button class="btn btn-primary btn-md w-auto rounded-xl" type="button" onClick={ChangePhone}>Edit</button>
                          }
                        {(GetOtpRes && !OTPVerify) ? 
   <button class="btn btn-primary btn-md w-auto rounded-xl" type="button" onClick={()=>{submitOTP(enquireData.phone)}}>Resend OTP</button>
 : !OTPVerify && <button class="btn btn-primary btn-md w-auto rounded-xl" type="button" onClick={()=>{submitOTP(enquireData.phone)}}>Send OTP</button>
  } 
                        </div>
                        {(GetOtpRes && !OTPVerify)  && 
                        <div className="mt-4 d-flex gap-2 col-8 border p-2 rounded w-100 bg-white">

                          <input
                          type="number"
                          id="otp"
                          className="form-control"
                          name="otp"
                          placeholder="Enter OTP"
                          value={enquireData.otp}
                          onChange={(e) => {
                            if (e.target.value.length <= 4) {
                              // Check input length before updating
                              handleChange(e); // Call handleChange if length is within limit
                            }
                          }}
                          onInput={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 4) {
                              setEnquireData({ ...enquireData, otp: inputValue });
                            }
                          }}
                        
                        />
                           <button class="btn btn-primary btn-md w-auto rounded-xl" type="button" onClick={()=>{verifyOTPFinal()}}>Verify</button>

                        </div>
                         }
                      </div>


                
                <div data-mdb-input-init="" className="form-outline mb-4 ">
                  <label className="form-label" htmlFor="form5Example2">
                    Requirement
                  </label>
                  <textarea
                     id="requirement"
                    className="form-control"
                    name="requirement"
                    value={enquireData.requirement}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                  <input
                    type="text"
                    id="service"
                    value={enquireData?.service}
                    className="form-control d-none"
                    style={{ boxShadow: "none" }}
                  />
                </div>

            <div className="row">
            <div   className="form-outline mb-4 col-6">
                  <label className="form-label" htmlFor="form5Example1">
                    Full Name
                  </label>
                  <input
                    type="text"
                    name="fullname"
                    id="form5Example1"
                    className="form-control"
                    value={enquireData.fullname}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>

                <div   className="form-outline mb-4 col-6 ">
                  <label className="form-label" htmlFor="form5Example2">
                    Email ID
                  </label>
                  <input
                    type="email"
                    id="form5Example2"
                    className="form-control"
                    name="email"
                    value={enquireData.email}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>

            </div>

                <div
                  className="d-block"
                  style={{ width: "fit-content !important" }}
                >
                  <button
                    type="button"
                    className="btn btn-primary w-100"
                    onClick={handleSendEnquire}
                    disabled={EnquireStatus} // Properly use the `disabled` attribute
                  >
                    Submit
                  </button>
                </div>


              </div>

              <div  
                className={`offcanvas offcanvas-collapse offcanvas-start d-none rounded-3 shadow ${Sidebar && "show"
                  }`}
                id="category-sidebar"
                style={{ maxWidth: "23rem" }}
              >
                <div className="offcanvas-header align-items-center shadow-sm d-none">
                  <h2 className="h5 mb-0">Filters</h2>
                  <button
                    className="btn-close ms-auto"
                    type="button"
                    onClick={Closesidebar}
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  />
                </div>

                {CatT.filter !== 0 && (
                  <div className="offcanvas-body p-lg-8 ">
                    {/* Categories */}
                    <div className="widget widget-categories pb-5 mb-5 ">
                      {/* Price Range Slider */}
                      <div className="widget pb-5 mb-5">
                        <h2>Filtered Products</h2>
                        {/* <ul>
          {filteredProducts.map(product => (
            <li key={product._id}>
              <img src={product.pImage} alt={product.title} />
              <p>{product.title}</p>
              <p>{`Sale Price: $${product.salePrice}`}</p>
            </li>
          ))}
        </ul>
 */}

                        {/* <h3 className="widget-title">Price</h3> */}
                        {filteredPriceRanges &&
                          filteredPriceRanges.length > 0 && <b>Price</b>}
                        <ul className="widget-list pt-1">
                          {filteredPriceRanges.map((range, index) => {
                            const isChecked = selectedRanges.includes(
                              `${range.min}-${range.max}`
                            );
                            return (
                              <li key={index} className="mb-1">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`checkbox-${index}`}
                                    value={`${range.min}-${range.max}`}
                                    onChange={handleCheckpriceboxChange}
                                    checked={isChecked}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`checkbox-${index}`}
                                  >
                                    ₹{range.min} - ₹{range.max}
                                  </label>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      {/* Price Range Slider */}
                      {/* <h3 className="widget-title">Categories</h3> */}

                      {/* Product category */}
{Attr.length} <br/>
{products.length}

{products.map((product) => (
  <div key={product._id}>
    <strong>Product:</strong> {product.slug}
    <ul>
      {product.variations?.map((variation, index) => (
        <li key={index}>{variation.name}</li>
      ))}
    </ul>
  </div>
))}

 

{Attr.map((attr, index) => {
  const hasVariations = products.some(
    (product) =>
      product.variations &&
      product.variations.some((variation) => variation.name === attr.name)
  );

  if (hasVariations) {
    return (
      <div className="accordion-item" key={attr._id}>
        <h2 className="accordion-header" id={`heading${index + 1}`}>
          <button
            className="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#collapse${index + 1}`}
            aria-expanded="true"
            aria-controls={`collapse${index + 1}`}
          >
            {attr.name}
          </button>
        </h2>
        <div
          id={`collapse${index + 1}`}
          className="accordion-collapse collapse show"
          aria-labelledby={`heading${index + 1}`}
          data-bs-parent="#accordionExample"
        >
          <div className="accordion-body">
            <ul className="widget-list pt-1">
              {attr.value.map((val, valIndex) => (
                <li className="mb-1" key={`${attr._id}-${valIndex}`}>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value={`${attr.name},${val}`}
                      onChange={handleCheckboxChange}
                      id={`checkbox-${valIndex}${attr._id}`}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`checkbox-${valIndex}${attr._id}`}
                    >
                      {val}
                    </label>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    );
  }

  return null;
})}


                    </div>
                    {/* Categories */}
                  </div>
                )}
              </div>
       
            {/* Sidebar */}
                      </div>
                    </div>
                 
                  </div>{" "}
                </>
              ) : (
                <div
                  className=" skeleton w-100 h-auto"
                  style={{ aspectRatio: "5/1", objectFit: "cover" }}
                />
              )}

              {!isDynamicCategoryLayout && <div className="row mt-4">
                {isCat
                  ? Array.from({ length: 4 }).map((_, index) => (
                    <div className="col-md-2 col-6">
                      <div
                        className="card-1 skeleton mb-2"
                        style={{ height: 200, borderRadius: 10 }}
                      ></div>
                    </div>
                  ))
                  : Cat.length > 0 &&
                  Cat.map((Cat) => (
                    <>
                      <div className="col-md-2 col-6">
                        <div className="p-0 bg-white rounded">
                          <Link className="col py-2 " to={`/${Cat.slug}`}>
                            <img
                              alt="ICU At Home"
                              width="100%"
                              className="rounded"
                              src={Cat.image}
                              style={{
                                width: "100%",
                                objectFit: "cover",
                                aspectRatio: "1 / 1",
                              }}
                            />
                            <h5 className="text-center text-primary fs-lg px-2 py-2">
                              {" "}
                              {Cat.title}{" "}
                            </h5>
                          </Link>
                        </div>
                      </div>
                    </>
                  ))}
              </div>}
              {/* Recommended Products Slider */}
              {/* Toolbar */}

              
              {!isDynamicCategoryLayout && CatT.filter !== 0 && (
                <div
                  className="card border-0 align-items-center mt-5 mb-4 flex-row  justify-content-between  "
                 >

                    {/* DESKTOP HORIZONTAL FILTER BAR */}
  <div className="d-none d-lg-flex gap-3 mb-4 flex-wrap ">
    {Attr.map((attr) => {

      const hasVariations = products.some(
        (product) =>
          product.variations &&
          product.variations.some(
            (variation) => variation.name === attr.name
          )
      );

      if (!hasVariations) return null;

      return (
        <div className="dropdown" key={attr._id}>
          <button
            className="btn btn-primary dropdown-toggle white"
            data-bs-toggle="dropdown"
          >
            {attr.name}
          </button>

          <div className="dropdown-menu p-3 shadow">
            {attr.value.map((val, valIndex) => {

              const isChecked = JSON.parse(Viewfillter || "{}")[attr.name]
                ?.split(",")
                .includes(val);

              return (
                <div className="form-check" key={valIndex}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value={`${attr.name},${val}`}
                    id={`desk-${attr._id}-${valIndex}`}
                    onChange={handleCheckboxChange}
                    checked={isChecked || false}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`desk-${attr._id}-${valIndex}`}
                  >
                    {val}
                  </label>
                </div>
              );
            })}
          </div>
        </div>
      );
    })}

<div className="d-inline-flex">
 
     <LocationSearchBox
  locations={LocationHeaders}
  showSearch={showSearch}
/> 
</div>

  </div>


                  
                <div className="d-flex align-items-center justify-content-between">
                        <form className="row row-cols-auto g-4 align-items-center me-3">
                          <div className="col m-0">
                            <div className="row g-2">
                              <label
                                htmlFor="sorting"
                                className="col-auto col-form-label d-sm-block"
                              >
                                No of products
                              </label>
                              <div className="col-auto">
                                <select
                                  className="form-select"
                                  id="sorting"
                                  value={count}
                                  onChange={handlecountChange}
                                >
                                  <option value="50">50</option>
                                  <option value="100">100</option>

                                  <option value="200">200</option>

                                  <option value="500">500</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </form>
                        <ul
                          className="nav nav-pills flex-nowrap"
                          id="pills-tab"
                          role="tablist"
                        >
                          <li
                            className="nav-item d-lg-none"
                            role="presentation"
                          >
                            <button
                               className="nav-link active py-2 px-3"
                               data-bs-toggle="offcanvas"
                            data-bs-target="#mobileFilter"
                            >
                              Fillter{" "}
                              <i className="ri-function-line fs-5 ms-2" />
                            </button>
                          </li>

                          
                        </ul>
                        
                      </div>

                </div>
              )}

<div className="container-fluid">

    
  {/* MOBILE SIDEBAR (OFFCANVAS) */}
  <div
    className="offcanvas offcanvas-start"
    tabIndex="-1"
    id="mobileFilter"
  >
    <div className="offcanvas-header border-bottom">
      <h5 className="offcanvas-title">Filters</h5>
      <button
        type="button"
        className="btn-close"
        data-bs-dismiss="offcanvas"
      ></button>
    </div>

    <div className="offcanvas-body">

      {Attr.map((attr) => {

        const hasVariations = products.some(
          (product) =>
            product.variations &&
            product.variations.some(
              (variation) => variation.name === attr.name
            )
        );

        if (!hasVariations) return null;

        return (
          <div className="mb-4" key={attr._id}>
            <h6 className="fw-semibold mb-2">{attr.name}</h6>

            {attr.value.map((val, valIndex) => {

              const isChecked = JSON.parse(Viewfillter || "{}")[attr.name]
                ?.split(",")
                .includes(val);

              return (
                <div className="form-check mb-2" key={valIndex}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value={`${attr.name},${val}`}
                    id={`mob-${attr._id}-${valIndex}`}
                    onChange={handleCheckboxChange}
                    checked={isChecked || false}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`mob-${attr._id}-${valIndex}`}
                  >
                    {val}
                  </label>
                </div>
              );
            })}
          </div>
        );
      })}

    </div>
  </div>

</div>


{isDynamicCategoryLayout && (
  <div
    className="offcanvas offcanvas-start"
    tabIndex="-1"
    id="dynamicCategoryFilter"
    aria-labelledby="dynamicCategoryFilterLabel"
  >
    <div className="offcanvas-header border-bottom">
      <h5 className="offcanvas-title" id="dynamicCategoryFilterLabel">Filters</h5>
      <button
        type="button"
        className="btn-close"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>

    <div className="offcanvas-body p-0">
      <div className="dentist-filter-rail border-0 rounded-0">
        <div className="dentist-filter-section">
          <div className="dentist-search-box d-flex align-items-center px-3 mb-3">
            <input
              className="form-control border-0 shadow-none"
              type="search"
              placeholder="Medical Service Provider Name"
              value={productSearchTerm}
              onChange={(event) => setProductSearchTerm(event.target.value)}
            />
            <i className="ri-search-line text-danger fs-4"></i>
          </div>
          <div className="dentist-filter-title">Filters</div>
        </div>
        {visibleFilterAttributes.map((attr) => (
          <div className="dentist-filter-section" key={`mobile-${attr._id}`}>
            <div className="fw-semibold mb-2">{attr.name}</div>
            {attr.value.map((val, valIndex) => {
              const isChecked = selectedFilters[`${attr.name},${val}`];
              return (
                <div className="form-check mb-2" key={`mobile-${attr._id}-${valIndex}`}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value={`${attr.name},${val}`}
                    id={`mobile-dynamic-filter-${attr._id}-${valIndex}`}
                    onChange={handleCheckboxChange}
                    checked={isChecked || false}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`mobile-dynamic-filter-${attr._id}-${valIndex}`}
                  >
                    {val}
                  </label>
                </div>
              );
            })}
          </div>
        ))}
        {filteredPriceRanges.length > 0 && (
          <div className="dentist-filter-section">
            <div className="fw-semibold mb-2">Price</div>
            {filteredPriceRanges.map((range, index) => {
              const isChecked = selectedRanges.includes(`${range.min}-${range.max}`);
              return (
                <div className="form-check mb-2" key={`mobile-price-${index}`}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`mobile-dynamic-price-${index}`}
                    value={`${range.min}-${range.max}`}
                    onChange={handleCheckpriceboxChange}
                    checked={isChecked}
                  />
                  <label className="form-check-label" htmlFor={`mobile-dynamic-price-${index}`}>
                    Rs {range.min} - Rs {range.max}
                  </label>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  </div>
)}


<div className="myfilter d-none">
 
{Attr.map((attr, index) => {
  const hasVariations = products.some(
    (product) =>
      product.variations &&
      product.variations.some((variation) => variation.name === attr.name)
  );

  // Parse the filters
  let parsedFilters = {};
  try {
    if (Viewfillter) {
      parsedFilters = JSON.parse(Viewfillter);
    }
  } catch (error) {
    console.error("Error parsing Viewfillter:", error);
  }

  // Check if there are any filters applied for this attribute
  const isFiltered = parsedFilters[attr.name];

  if (hasVariations) {
    return (
      <div className="d-block" key={attr._id}>
        <h4 className="m-0 mt-2">{attr.name}</h4>
        <hr className="w" />
        <div className="d-flex gap-2">
          {attr.value.map((val, valIndex) => {
            // Check if this value is checked in the current filter
            const isChecked = parsedFilters[attr.name]
              ?.split(",")
              .includes(val);

            return (
              <span className={`mb-1 ${isChecked ? 'bg-primary' : 'btn-outline-primary'}`} key={`${attr._id}-${valIndex}`}>
                <div className={`px-3 py-2 rounded ${isChecked ? 'text-white': 'text-dark'}`}>
                  <input
                    className="d-none"
                    type="checkbox"
                    value={`${attr.name},${val}`}
                    onChange={handleCheckboxChange}
                    id={`checkbox-${valIndex}${attr._id}`}
                   />
                  <label
                    className="form-check-label m-0 p-0" type="button"
                    htmlFor={`checkbox-${valIndex}${attr._id}`}
                  >
                    {val}
                  </label>
                </div>
              </span>
            );
          })}
        </div>
      </div>
    );
  }

  return null;
})}
</div>

              {/* Toolbar */}

              {/* {Viewfillter && (
                <div className="w-100">
                  {(() => {
                    try {
                      const parsedFilters = JSON.parse(Viewfillter);
                      return Object.entries(parsedFilters).map(
                        ([key, value]) => (
                          <span key={key} className="w-100">
                            {value.split(",").map((val) => (
                              <button
                                onClick={() => removeFilter({ key, val })}
                                className="btn btn-sm btn-secondary py-1 px-2 ms-1 mb-2"
                                key={`${key}-${val}`}
                              >
                                {`${key}: ${val}`} <i class="ri-close-line"></i>
                              </button>
                            ))}
                          </span>
                        )
                      );
                    } catch (error) {
                      console.error("Error parsing Viewfillter:", error);
                      return <div>No filters Found</div>;
                    }
                  })()}
                </div>
              )} */}

              {/* <h2 className="h3 border-bottom pb-4 mb-4">
                Results for   {CatT ? <>  {CatT}  </> : <> loading.. </>}
              </h2> */}

<div className="row">
  {isDynamicCategoryLayout && (
    <div className="col-lg-3 mb-4 d-none d-lg-block">
      <div className="dentist-filter-rail">
        <div className="dentist-filter-section">
          <div className="dentist-search-box d-flex align-items-center px-3 mb-3">
            <input
              className="form-control border-0 shadow-none"
              type="search"
              placeholder="Medical Service Provider Name"
              value={productSearchTerm}
              onChange={(event) => setProductSearchTerm(event.target.value)}
            />
            <i className="ri-search-line text-danger fs-4"></i>
          </div>
          <div className="dentist-filter-title">Filters</div>
        </div>
        {visibleFilterAttributes.map((attr) => (
          <div className="dentist-filter-section" key={attr._id}>
            <div className="fw-semibold mb-2">{attr.name}</div>
            {attr.value.map((val, valIndex) => {
              const isChecked = selectedFilters[`${attr.name},${val}`];
              return (
                <div className="form-check mb-2" key={`${attr._id}-${valIndex}`}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value={`${attr.name},${val}`}
                    id={`dentist-filter-${attr._id}-${valIndex}`}
                    onChange={handleCheckboxChange}
                    checked={isChecked || false}
                  />
                  <label
                    className="form-check-label" style={{textTransform:'capitalize'}}
                    htmlFor={`dentist-filter-${attr._id}-${valIndex}`}
                  >
                    {val}
                  </label>
                </div>
              );
            })}
          </div>
        ))}
        {filteredPriceRanges.length > 0 && (
          <div className="dentist-filter-section d-none">
            <div className="fw-semibold mb-2">Price</div>
            {filteredPriceRanges.map((range, index) => {
              const isChecked = selectedRanges.includes(`${range.min}-${range.max}`);
              return (
                <div className="form-check mb-2" key={index}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`dentist-price-${index}`}
                    value={`${range.min}-${range.max}`}
                    onChange={handleCheckpriceboxChange}
                    checked={isChecked}
                  />
                  <label className="form-check-label" htmlFor={`dentist-price-${index}`}>
                    Rs {range.min} - Rs {range.max}
                  </label>
                </div>
              );
            })}
          </div>
        )}
      </div>
      {/* <div className="dentist-preferred-lab">
        <div className="fw-bold fs-5 mb-2">Couldn't find your preferred lab</div>
        <p className="mb-3">we will try and add your preferred lab on our platform.</p>
        <button type="button" className="btn dentist-book-btn w-100">Specify Your Preferred Lab</button>
      </div> */}
    </div>
  )}
  
  
 
                <div className={`mt-4 ${isDynamicCategoryLayout ? "col-lg-9" : "col-md-12"}`}>
                  <div className={`d-flex mb-3 border px-2 bg-white rounded ${isDynamicCategoryLayout ? "d-none" : ""}`}>
                    <i className="ri-search-line align-self-center text-muted"></i>
                    <input
                      className="form-control border-0 shadow-none"
                      type="search"
                      placeholder="Medical Service Provider Name"
                      value={productSearchTerm}
                      onChange={(event) => setProductSearchTerm(event.target.value)}
                    />
                  </div>
                  {isDynamicCategoryLayout && (
                    <>
                      <div className="mb-3">
                        <h1 className="h3 text-danger fw-bold d-inline me-2">
                          {CatT?.title ||  " "}
                        </h1>
                       </div>
                      <div className="dentist-mobile-toolbar d-lg-none">
                        <button
                          className="dentist-mobile-filter-btn"
                          type="button"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#dynamicCategoryFilter"
                          aria-controls="dynamicCategoryFilter"
                        >
                          <i className="ri-filter-3-line"></i>
                          <span>Filters</span>
                        </button>
                        <span className="fw-semibold small text-muted">
                          {searchedProducts.length} Results
                        </span>
                      </div>
                      <div className="mb-3">
                        {Object.keys(parsedViewFilters).length > 0 ? (
                          Object.entries(parsedViewFilters).map(([key, value]) =>
                            value.split(",").map((val) => (
                              <button
                                type="button"
                                onClick={() => removeFilter({ key, val })}
                                className="dentist-chip"
                                key={`${key}-${val}`}
                              >
                                <span>{val}</span>
                                <i className="ri-close-line"></i>
                              </button>
                            ))
                          )
                        ) : (
                          ''
                        )}
                      </div>
                      {lookingForTabs.length > 0 && (
                        <div className="dentist-tabs">
                          {lookingForTabs.map((tab) => (
                            <button
                              className={`dentist-tab ${activeLookingForValues.includes(tab.value) ? "active" : ""}`}
                              type="button"
                              key={`${lookingForAttribute.name}-${tab.value}`}
                              onClick={() => handleLookingForTabChange(lookingForAttribute.name, tab.value)}
                            >
                              {tab.label}
                            </button>
                          ))}
                        </div>
                      )}
                      <div className="dentist-table-head">
                        <span>Labs Name <i className="ri-sort-desc"></i></span>
                        <span>Test Details <i className="ri-sort-desc"></i></span>
                        <span>Rating <i className="ri-sort-desc"></i></span>
                        <span>Price <i className="ri-sort-desc"></i></span>
                        <span></span>
                      </div>
                    </>
                  )}

                  {/* Heading */}
   <div
                className={`tab-content ${CatT.filter === 0 && "d-none"}`}
                id="pills-tabContent"
              >
                {/* Product Grid */}
                <div
                  className="tab-pane fade show active"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  {/* Product Cards */}
                  <div className="row pt-2 mx-n2 mb-4 mb-sm-8 bg-light pb-4 border rounded-4 category-feature-grid">
                    {isCat
                      ? Array.from({ length: 6 }).map((_, index) => (
                        <div
                          key={index}
                          className="col-lg-3 col-md-4 col-sm-6 mt-4"
                        >
                          <div
                            className="card-1 skeleton"
                            style={{ height: 430, borderRadius: 5 }}
                          ></div>
                        </div>
                      ))
                      : searchedProducts.map((Pro) => {
                        const featureList = Array.isArray(Pro.features)
                          ? Pro.features.filter(Boolean).map((feature) =>
                              typeof feature === "string"
                                ? feature
                                : feature?.title || feature?.name || String(feature)
                            )
                          : [];
                        const productImage =
                          Pro.pImage ||
                          Pro.image ||
                          Pro.images?.[0]?.src ||
                          Pro.images?.[0] ||
                          "/assets/img/placeholder.png";
                        const productRating = Number(Pro.avgRating || 0);
                        return (
                          <>
                           {/* Product */}
<div className={isDynamicCategoryLayout ? "dentist-list-col" : "col-sm-6 col-6 col-md-4 px-2 mb-4 category-feature-col"}>
  <div className={`card card-product h-100 bg-light border rounded-4 bgw-white category-feature-card ${isDynamicCategoryLayout ? "dentist-list-card" : ""}`}>
    <Link to={`/product/${Pro.slug}`} className={`d-block bg-white rounded-top overflow-hidden ${isDynamicCategoryLayout ? "dentist-product-image" : ""}`}>
      <img
        src={productImage}
        alt={Pro.title}
        className="w-100"
        style={{ height: 160, objectFit: "cover" }}
      />
    </Link>
    <div className="card-body p-2">

      {/* Product Title + Badge */}
      <div className={`row justify-content-between w-100 p-0 m-0 ${isDynamicCategoryLayout ? "dentist-main-cell" : ""}`}>
        {isDynamicCategoryLayout && (
          <img
            src={productImage}
            alt={Pro.title}
            className="dentist-inline-image"
          />
        )}
        <div className="col">
          <h3 className="product-title mt-2">
            <Link to={`/product/${Pro.slug}`}>
              {Pro.title}
            </Link>
          </h3>
          {isDynamicCategoryLayout && (
            <div className="dentist-muted-line">
              <div><i className="ri-map-pin-line text-danger"></i> {Pro.userId?.address || Pro.userId?.username || capitalizedLocation}</div>
              <div><i className="ri-calendar-line text-danger"></i> <b>Timings:</b> {Pro.timings || Pro.userId?.timings || "All Days 8 AM to 8 PM"}</div>
            </div>
          )}
        </div>

        <div className={`col-md-4 text-end ${isDynamicCategoryLayout ? "d-none" : ""}`}>
          <span className="badge text-danger bg-white btn-outline-danger">
            Health
          </span>
        </div>

         {/* ⭐ Rating Section */}
      <div className={`d-flex align-items-center mt-1 mb-2 col-12 ${isDynamicCategoryLayout ? "d-none" : ""}`}>
        <div className="text-warning me-2">
          {[1, 2, 3, 4, 5].map((star) => (
            <i
              key={star}
              className={
                Pro.avgRating >= star
                  ? "ri-star-fill"
                  : Pro.avgRating >= star - 0.5
                  ? "ri-star-half-fill"
                  : "ri-star-line"
              }
            ></i>
          ))}
        </div>
        <small className="text-muted">
          ({Pro.ratingCount || 0} Reviews)
        </small>
      </div>

      </div>

     
      {featureList.length > 0 && (
        <div className={`product-key-features mt-2 ${isDynamicCategoryLayout ? "dentist-detail-cell" : ""}`}>
          {isDynamicCategoryLayout && (
            <>
              <div className="dentist-detail-title">{Pro.title}</div>
              <div className="dentist-feature-hover bg-primary text-white rounded px-2" tabIndex={0}>
                Key Features: {featureList.length}
                <div className="dentist-feature-popover">
                  <div className="dentist-feature-popover-title">Key Features</div>
                  <ul>
                    {featureList.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                </div>
              </div>
             </>
          )}
          {!isDynamicCategoryLayout && (
            <>
          <button
            type="button"
            className="product-key-features-trigger"
            aria-label={`Show key features for ${Pro.title}`}
          >
            <i className="ri-microscope-line"></i>
            <span>Key Features</span>
            <i className="ri-arrow-down-s-line"></i>
          </button>
          <div className="product-key-features-list">
            <div className="product-key-features-list-title">
              <i className="ri-flask-line"></i>
              <span>Included key features</span>
            </div>
            {featureList.map((feature, index) => (
              <div key={index} className="product-key-feature-item">
                <i class="ri-arrow-right-s-line"></i>
                <span>{feature}</span>
              </div>
            ))}
          </div>
            </>
          )}
          
        </div>
      )}
      {isDynamicCategoryLayout && featureList.length === 0 && (
        <div className="dentist-detail-cell">
          <div className="dentist-detail-title">{Pro.title}</div>
          {/* <div>Test Included: 0</div> */}
         </div>
      )}
      {isDynamicCategoryLayout && (
        <>
          
          <div className="dentist-rating-cell">
            {productRating > 0 ? (
              <span className="dentist-rating-badge">
                {productRating.toFixed(1)} <i className="ri-star-fill text-warning"></i>
              </span>
            ) : (
              <span className="text-muted small">No ratings</span>
            )}
          </div>
        </>
      )}

      {/* Parameters + Report */}
      {/* <div className="row justify-content-between w-100 p-0 m-0">
        <div className="col">
          <b className="d-block m-0 p-0">
            <i className="ri-microscope-line"></i> {Pro.features.length} Parameters
          </b>
          <div>Include</div>
        </div>

        <div className="col text-md-end fs-8">
          <b className="d-block m-0 p-0">
            <i className="ri-calendar-todo-fill"></i> Report
          </b>
          <div>Same Day</div>
        </div>
      </div> */}

      {/* Price + Button */}
      {isDynamicCategoryLayout ? (
        <>
          <div className="dentist-price-cell">
            {Pro.salePrice === 0 ? (
              <span>Price On request</span>
            ) : (
              <span className="fs-5">
                ₹{Pro.salePrice}
                <del className="ms-1">
                  <small>₹{Pro.regularPrice}</small>
                </del>
              </span>
            )}
          </div>

          <div className="dentist-action-cell">
            <Link
              className="btn btn-sm btn-primary dentist-book-btn"
              to={`/product/${Pro.slug}`}
            >
              Book
            </Link>
          </div>
        </>
      ) : (
        <div className="row justify-content-between align-items-center w-100 p-0 m-0">
          <div className="product-price col mt-2">
            {Pro.salePrice === 0 ? (
              <span className="text-danger">
                Price On request
              </span>
            ) : (
              <span className="text-danger fs-5">
                ₹{Pro.salePrice}
                <del className="text-body-secondary ms-1">
                  <small>₹{Pro.regularPrice}</small>
                </del>
              </span>
            )}
          </div>

          <div className="col-auto mt-2">
            <Link
              className="btn btn-sm btn-primary"
              to={`/product/${Pro.slug}`}
            >
              Book Now
            </Link>
          </div>
        </div>
      )}

    </div>
  </div>
</div>
{/* Product */}
                          </>
                        );
                      })}

                    {searchedProducts.length === 0 && !isCat && (
                      <div
                        className="container mx-auto my-2 mt-5 py-2 bg-white text-center bg-transparent"
                        style={{
                          height: 193,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <p>No products found for this category.</p>
                      </div>
                    )}

                    <hr className=" d-sm-block" />
                    {/* Pagination */}
                    {/* 
              <div className="d-flex justify-content-between mt-6">
                <ul className="pagination">
                  <li className="page-item">
                    <a className="page-link" href="#">
                      <i className="ri-arrow-left-s-line me-1" />
                      Prev
                    </a>
                  </li>
                </ul>
                <ul className="pagination">
                  <li className="page-item d-sm-none">
                    <span className="page-link page-link-static">1 / 5</span>
                  </li>
                  <li
                    className="page-item active d-none d-sm-block"
                    aria-current="page"
                  >
                    <span className="page-link">
                      1<span className="visually-hidden">(current)</span>
                    </span>
                  </li>
                  <li className="page-item d-none d-sm-block">
                    <a className="page-link" href="#">
                      2
                    </a>
                  </li>
                  <li className="page-item d-none d-sm-block">
                    <a className="page-link" href="#">
                      3
                    </a>
                  </li>
                  <li className="page-item d-none d-sm-block">
                    <a className="page-link" href="#">
                      4
                    </a>
                  </li>
                  <li className="page-item d-none d-sm-block">
                    <a className="page-link" href="#">
                      5
                    </a>
                  </li>
                </ul>
                <ul className="pagination">
                  <li className="page-item">
                    <a className="page-link" href="#" aria-label="Next">
                      Next
                      <i className="ms-1 ri-arrow-right-s-line" />
                    </a>
                  </li>
                </ul>
              </div> */}

                    <div className="d-flex justify-content-between mt-6">
                      <ul className="pagination">
                        <li
                          className={`page-item ${currentPage === 1 ? "disabled" : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            type="button"
                            onClick={() => handlePageChange(currentPage - 1)}
                          >
                            <i className="ri-arrow-left-s-line me-1"></i>Prev
                          </button>
                        </li>
                      </ul>
                      {/* <ul className="pagination">
          {Array.from({ length: totalPages }, (_, index) => (
            <li className={`page-item ${currentPage === index + 1 ? 'active' : ''}`} key={index}>
              <button className="page-link"  type="button" onClick={() => handlePageChange(index + 1)}>{index + 1}</button>
            </li>
          ))}
        </ul> */}
                      <ul className="pagination">
                        <li
                          className={`page-item ${totalPages === 0 ? "disabled" : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            type="button"
                            onClick={() => handlePageChange(currentPage + 1)}
                            aria-label="Next"
                          >
                            Next<i className="ms-1 ri-arrow-right-s-line"></i>
                          </button>
                        </li>
                      </ul>
                    </div>

                    {/* Pagination */}
                  </div>
                  {/* Product Cards */}
                </div>
                {/* Product Grid */}
                {/* Product List */}

                {/* Product List */}
              </div>

              
                  <div dangerouslySetInnerHTML={{ __html: CatT.description?.replace(/\$\{location\}/g, capitalizedLocation) }} />
                </div>
     
 
  </div>
 
 
            </aside>
            {/* Content */}
          </div>
         

          {Specifications.length !== 0 &&
            Specifications.map((specification, specIndex) => (
              <>
                <section className="my-4 py-4">
                  <h3 className="text-start mb-3">{specification.heading}</h3>
                  <div className="accordion" id={`accordionID` + specIndex}>
                    {specification.labels.map((label, labelIndex) => (
                      <>
                        <div
                          className="accordion-item mb-2 border rounded overflow-hidden bg-light-theme "
                          key={labelIndex}
                        >
                          <div className="accordion-header bg-transparent">
                            <h4
                              style={{ fontSize: 20, fontWeight: 600 }}
                              className="accordion-button h3 collapsed bg-transparent text-white"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapseOne${labelIndex}`}
                              aria-expanded="false"
                              aria-controls={`#collapseOne${labelIndex}`}
                            >
                              {label.label?.replace(/\$\{location\}/g, capitalizedLocation)}
                            </h4>
                          </div>
                          <div
                            id={`collapseOne${labelIndex}`}
                            className="accordion-collapse collapse"
                            data-bs-parent={`#accordionID${specIndex}`}
                          >
                            <div className="accordion-body text-white">{label.value?.replace(/\$\{location\}/g, capitalizedLocation)}</div>
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                </section>
              </>
            ))}

 

          {/* Product Cards */}

          {/* <div className="container pb-4 pb-lg-10 d-none">
             <div className="d-flex flex-wrap justify-content-between align-items-center pt-1 border-bottom pb-4 mb-4">
              <h2 className="h3 mb-0 me-2">Recommended Products</h2>
              <div className="ms-n4">
              
              </div>
            </div>
            
            <div className="row pt-2 mx-n2 hero-swiper hide-desk-arrow">
         
              <Swiper
                breakpoints={{
                  300: {
                    slidesPerView: 2,
                    spaceBetween: 10, // Set the gap between slides for window width <= 400px
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 20, // Set the gap between slides for window width <= 768px
                  },
                  992: {
                    slidesPerView: 3,
                    spaceBetween: 25, // Set the gap between slides for window width <= 992px
                  },
                  1200: {
                    slidesPerView: 5,
                    spaceBetween: 20, // Set the gap between slides for window width <= 1200px
                  },
                }}
                pagination={true}
                modules={[Pagination, Navigation]}
                className="swiper-wrapper"
              >
                {isProducts
                  ? Array.from({ length: 7 }).map((_, index) => (
                    <SwiperSlide key={index}>
                      <div
                        className="card-1 skeleton"
                        style={{ height: 371, borderRadius: 10 }}
                      ></div>
                    </SwiperSlide>
                  ))
                  : layout.recommended_products && (
                    <>
                      {RProducts.map((product, index) => {
                        const productRatings = ratings.filter(
                          (rating) => rating.productId === product._id
                        );
                        const totalRatings = productRatings.length;
                        const totalRatingValue = productRatings.reduce(
                          (acc, curr) => acc + curr.rating,
                          0
                        );
                        const averageRating =
                          totalRatings > 0
                            ? totalRatingValue / totalRatings
                            : 0;

                        console.log("layout.trending_product.", layout);
                        const myslug = CreateSlug(product.title); // Make sure `data` and `Product` are defined and available in the scope.

                        return (
                          layout.recommended_products.includes(
                            product._id
                          ) && (
                            <>
                              <SwiperSlide key={index}>
                           
                              <div className="col-sm-6 col-6 col-md-4 px-2 mb-4">
                              <div className="card card-product h-100 bg-light border rounded-4 overflow-hidden bgw-white">
                             
                                <div className="product-buttons">
                                  <button
                                    className="btn-product btn-wishlist"
                                    type="button"
                                    data-bs-toggle="button"
                                    title="Add to wishlist"
                                  >
                                    <i className="ri-heart-line" />
                                  </button>
                                  <Link
                                    className="btn-product btn-compare"
                                    href="#"
                                    title="Compare product"
                                  >
                                    <i className="ri-repeat-line" />
                                  </Link>
                                </div>
                            
                                
                                <div className="card-body p-2 ">
                               
 
                                  <div className="row justify-content-between w-100 p-0 m-0">
<div className="col">

<h3 className="product-title  mt-2">
                                    <Link to={`/product/${Pro.slug}`}>
                                      {" "}
                                      {Pro.title}{" "}
                                    </Link>
                                  </h3>
</div>
 <div className="col-md-4 text-end">
 <span class="badge btn text-danger bg-white btn-outline-danger">Health</span>

 
 </div>
                                 
                                  </div>

                                  <div className="row justify-content-between w-100 p-0 m-0">
                                    <div className="col">
                                    
                                  
<b className="d-block m-0 p-0">   <i class="ri-microscope-line"></i> {Pro.features.length} Parameters  </b> 
<div>Include</div>
                                    </div>

                                    <div className="col text-md-end fs-8">
                                    
                                  
                                    <b className="d-block m-0 p-0">   <i class="ri-calendar-todo-fill"></i>
                                     Report  </b> 
                                    <div>Same Day</div>
                                      </div>

                                  </div>

 
                                  <div className="row justify-content-between w-100 p-0 m-0">
                                  <div className="product-price col mt-2 ">
                                    {Pro.salePrice === 0 ? (
                                      <span
                                        className="text-danger"
                                        style={{ color: "red" }}
                                      >
                                        Price On request
                                      </span>
                                    ) : (
                                      <span className="text-danger fs-5">
                                        ₹{Pro.salePrice}
                                        <del className="text-body-secondary ms-1">
                                          <small>₹{Pro.regularPrice}</small>
                                        </del>
                                      </span>
                                    )}

                                  
                                  </div>

                                  <Link className="btn btn-sm btn-primary col-md-1 w-auto mt-2 " to={`/product/${Pro.slug}`}>
Book Now
                                  </Link>
                                  </div>
                              
                                </div>
                               
                              </div>
                            </div>
                
                              </SwiperSlide>
                            </>
                          )
                        );
                      })}
                    </>
                  )}
              </Swiper>
            </div>
        
          </div> */}
         
        </div>
 
      </div>

      <Footer />
    </>
  );
};

export default Category;
